"use strict";

exports.__esModule = true;
exports.AdvancedStripeChartWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _StripeChart = require("../StripeChart");
var _AdvancedStripeChartFields = require("./AdvancedStripeChartFields");
var _AdvancedStripeChartElement = require("./AdvancedStripeChartElement");
var _ChartCard = require("../common/ChartCard");
var _AdvancedStripeChartHeader = require("./AdvancedStripeChartHeader");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AdvancedStripeChartWidget = exports.AdvancedStripeChartWidget = {
  name: "AdvancedStripeChartWidget",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AdvancedStripeChartWidget.label",
    defaultMessage: "Advanced Stripe Chart"
  }),
  icon: "timeline-area-chart",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AdvancedStripeChartWidget",
      props: Object.assign({
        width: 200,
        height: 150,
        timeline: "",
        labels: [],
        showDivision: true,
        hideXAxis: false,
        showComments: false,
        showTickets: false,
        showAlerts: false,
        dataRange: "",
        showBrush: false,
        colorSource: "custom",
        backgroundColor: "#000",
        labelColor: "#fff",
        columnLabel: "test"
      }, props),
      children: []
    };
  },
  isParent: false,
  showInPalette: true,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["brushEnableDragging", "brushEnableResize", "brushEnableSnapToSelection", "brushEnableSnapToTimeline", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 200,
      min: 64,
      max: 3840
    },
    height: {
      "default": 150,
      min: 64,
      max: 2160
    }
  },
  components: {
    Header: _AdvancedStripeChartHeader.AdvancedStripeChartHeader,
    Element: (0, _ChartCard.withChartCard)(_AdvancedStripeChartElement.AdvancedStripeChartElement, function () {
      return {
        title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "AdvancedStripeChartWidget.card.title",
          defaultMessage: "State timeline"
        })
      };
    }),
    Fields: _AdvancedStripeChartFields.AdvancedStripeChartFields,
    Thumbnail: _StripeChart.StripeChartThumbnail
  }
};